var render = function render(){var _vm=this,_c=_vm._self._c;return _c('acne-scars-template',{attrs:{"face-scars-appearance":_vm.faceScarsAppearance,"title":_vm.facialScarsTitle,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }